export default {
  root: ({ context }) => ({
    class: [
      // Font
      'font-bold font-sans',
      'text-xs leading-5',

      // Alignment
      'flex items-center justify-center',
      'text-center',

      // Position
      'absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 origin-top-right',

      // Size
      'm-0',
      {
        'p-0': context.nogutter || context.dot,
        'px-2': !context.nogutter && !context.dot,
        'min-w-[0.5rem] w-2 h-2': context.dot,
        'min-w-[1.5rem] h-6': !context.dot
      },

      // Shape
      {
        'rounded-full': context.nogutter || context.dot,
        'rounded-[10px]': !context.nogutter && !context.dot
      },

      // Color
      'text-white dark:text-secondary-900',
      {
        'bg-primary-500 dark:bg-primary-400':
          !context.info &&
          !context.success &&
          !context.warning &&
          !context.danger &&
          !context.help &&
          !context.secondary,
        'bg-secondary-500 dark:bg-secondary-400': context.secondary,
        'bg-green-500 dark:bg-green-400': context.success,
        'bg-info-500 dark:bg-info-400': context.info,
        'bg-warning-500 dark:bg-warning-400': context.warning,
        'bg-purple-500 dark:bg-purple-400': context.help,
        'bg-danger-500 dark:bg-danger-400': context.danger
      }
    ]
  })
};
